import SignaturesTable from "./SignaturesTable";

const Signatures = ({}) =>{
    return(
        <>
        <SignaturesTable /> 
        </>
    )
}

export default Signatures;